<div *ngIf="isDesktop" #tooltip="matTooltip" [matTooltip]="tooltipText" [matTooltipPosition]="tooltipConfig.position"
  [matTooltipHideDelay]="tooltipConfig.delay" [attr.aria-label]="tooltipText" [matTooltipClass]="font?.size">
  <ng-content *ngTemplateOutlet="contentTpl"></ng-content>
</div>

<div *ngIf="!isDesktop" (click)="openModal()">
  <ng-content *ngTemplateOutlet="contentTpl"></ng-content>
</div>

<ng-template #contentTpl><ng-content></ng-content></ng-template>